import React from "react";
export default function getSVG(type, color) {
  switch (type) {
    case "chat-active":
      return (
        <svg width="73" height="81" viewBox="0 10 73 81" fill="none">
          <g filter="url(#filter0_d)">
            <path
              d="M53 54L52.1865 54.9491L54.25 56.7178L54.25 54L53 54ZM44.8333 47L45.6468 46.0509L45.2957 45.75L44.8333 45.75L44.8333 47ZM53 42L51.75 42L53 42ZM53 19L54.25 19L53 19ZM20 19L21.25 19L20 19ZM20 42L18.75 42L20 42ZM25 47L25 48.25L25 47ZM53.8135 53.0509L45.6468 46.0509L44.0198 47.9491L52.1865 54.9491L53.8135 53.0509ZM51.75 42L51.75 54L54.25 54L54.25 42L51.75 42ZM51.75 19L51.75 42L54.25 42L54.25 19L51.75 19ZM48 15.25C50.0711 15.25 51.75 16.9289 51.75 19L54.25 19C54.25 15.5482 51.4518 12.75 48 12.75L48 15.25ZM25 15.25L48 15.25L48 12.75L25 12.75L25 15.25ZM21.25 19C21.25 16.9289 22.9289 15.25 25 15.25L25 12.75C21.5482 12.75 18.75 15.5482 18.75 19L21.25 19ZM21.25 42L21.25 19L18.75 19L18.75 42L21.25 42ZM25 45.75C22.9289 45.75 21.25 44.0711 21.25 42L18.75 42C18.75 45.4518 21.5482 48.25 25 48.25L25 45.75ZM44.8333 45.75L25 45.75L25 48.25L44.8333 48.25L44.8333 45.75Z"
              fill={color ? color : "#1C4E80"}
            />
          </g>
          <path
            d="M26 36C29.3333 39.0185 38 43.2444 46 36"
            stroke={color ? color : "#1C4E80"}
            stroke-width="2.5"
            stroke-linecap="round"
          />
          <defs>
            <filter
              id="filter0_d"
              x="0.75"
              y="0.75"
              width="71.5"
              height="79.9678"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="6" />
              <feGaussianBlur stdDeviation="9" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      );

    case "chat-inactive":
      return (
        <svg width="73" height="81" viewBox="0 10 73 81" fill="none">
          <g filter="url(#filter0_d)">
            <path
              d="M53 54L52.1865 54.9491L54.25 56.7178L54.25 54L53 54ZM44.8333 47L45.6468 46.0509L45.2957 45.75L44.8333 45.75L44.8333 47ZM53 42L51.75 42L53 42ZM53 19L54.25 19L53 19ZM20 19L21.25 19L20 19ZM20 42L18.75 42L20 42ZM25 47L25 48.25L25 47ZM53.8135 53.0509L45.6468 46.0509L44.0198 47.9491L52.1865 54.9491L53.8135 53.0509ZM51.75 42L51.75 54L54.25 54L54.25 42L51.75 42ZM51.75 19L51.75 42L54.25 42L54.25 19L51.75 19ZM48 15.25C50.0711 15.25 51.75 16.9289 51.75 19L54.25 19C54.25 15.5482 51.4518 12.75 48 12.75L48 15.25ZM25 15.25L48 15.25L48 12.75L25 12.75L25 15.25ZM21.25 19C21.25 16.9289 22.9289 15.25 25 15.25L25 12.75C21.5482 12.75 18.75 15.5482 18.75 19L21.25 19ZM21.25 42L21.25 19L18.75 19L18.75 42L21.25 42ZM25 45.75C22.9289 45.75 21.25 44.0711 21.25 42L18.75 42C18.75 45.4518 21.5482 48.25 25 48.25L25 45.75ZM44.8333 45.75L25 45.75L25 48.25L44.8333 48.25L44.8333 45.75Z"
              fill="#9D9D9D"
            />
          </g>
          <path
            d="M26 36C29.3333 39.0185 38 43.2444 46 36"
            stroke="#9D9D9D"
            stroke-width="2.5"
            stroke-linecap="round"
          />
          <path
            d="M17 17L55 50"
            stroke="white"
            stroke-width="2.5"
            stroke-linecap="round"
          />
          <path
            d="M18 15L56 48"
            stroke="#9D9D9D"
            stroke-width="2.5"
            stroke-linecap="round"
          />
          <defs>
            <filter
              id="filter0_d"
              x="0.75"
              y="0.75"
              width="71.5"
              height="79.9678"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="6" />
              <feGaussianBlur stdDeviation="9" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      );
    case "notification-active":
      return (
        <svg width="20" height="43" viewBox="0 0 37 43" fill="none">
          <path
            d="M34.7677 30.7558L33.118 28.2812C30.4784 24.3219 29.1586 19.5376 29.1586 14.7534C29.1586 9.63925 25.8591 5.34994 21.4049 4.03015C20.9099 2.71036 19.5902 1.8855 18.2704 1.8855C16.9506 1.8855 15.6308 2.71036 15.1359 4.03015C10.6816 5.34994 7.38213 9.63925 7.38213 14.7534C7.38213 19.5376 6.06235 24.3219 3.42277 28.2812L1.77304 30.7558C1.11315 31.9106 1.77304 33.2304 3.09283 33.2304H33.2829C34.6027 33.2304 35.4276 31.7457 34.7677 30.7558Z"
            stroke={color ? color : "#1C4E80"}
            stroke-width="2.5"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
          <path
            d="M23.2194 36.4614C23.2194 39.266 21.0748 41.4106 18.2702 41.4106C15.4657 41.4106 13.321 39.266 13.321 36.4614"
            stroke={color ? color : "#1C4E80"}
            stroke-width="2.5"
            stroke-miterlimit="10"
            stroke-linejoin="round"
          />
        </svg>
      );

    case "arrow-up":
      return (
        <svg
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="2.5"
          stroke="currentColor"
          class="w-6 h-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75"
          />
        </svg>
      );
    case "arrow-down":
      return (
        <svg
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="2.5"
          stroke="currentColor"
          class="w-6 h-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 4.5v15m0 0l6.75-6.75M12 19.5l-6.75-6.75"
          />
        </svg>
      );

    case "close-icon":
      return (
        <svg fill={color ? color : "#000000"} viewBox="0 0 26 26">
          <path d="M 21.734375 19.640625 L 19.636719 21.734375 C 19.253906 22.121094 18.628906 22.121094 18.242188 21.734375 L 13 16.496094 L 7.761719 21.734375 C 7.375 22.121094 6.746094 22.121094 6.363281 21.734375 L 4.265625 19.640625 C 3.878906 19.253906 3.878906 18.628906 4.265625 18.242188 L 9.503906 13 L 4.265625 7.761719 C 3.882813 7.371094 3.882813 6.742188 4.265625 6.363281 L 6.363281 4.265625 C 6.746094 3.878906 7.375 3.878906 7.761719 4.265625 L 13 9.507813 L 18.242188 4.265625 C 18.628906 3.878906 19.257813 3.878906 19.636719 4.265625 L 21.734375 6.359375 C 22.121094 6.746094 22.121094 7.375 21.738281 7.761719 L 16.496094 13 L 21.734375 18.242188 C 22.121094 18.628906 22.121094 19.253906 21.734375 19.640625 Z" />
        </svg>
      );

    case "expand-controls-list":
      return (
        <svg
          viewBox="0 0 20 20"
          fill={color ? color : "#000"}
          class="text-[#344054] group-focus:text-blue-primary"
        >
          <path
            d="M6.66667 5H17.5M6.66667 10H17.5M6.66667 15H17.5M2.5 5H2.50833M2.5 10H2.50833M2.5 15H2.50833"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      );
    case "expand-controls-headline":
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          class="text-[#344054] group-focus:text-blue-primary w-5 h-5"
        >
          <path
            d="M21 10H3M21 6H3M21 14H3M21 18H3"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      );
    case "double-arrow-down":
      return (
        <svg
          class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSvgIcon-root MuiSvgIcon-fontSizeLarge css-zjt8k"
          focusable="false"
          aria-hidden="true"
          viewBox="0 0 24 24"
          data-testid="KeyboardDoubleArrowDownIcon"
          tabindex="-1"
          title="KeyboardDoubleArrowDown"
        >
          <path d="M18 6.41 16.59 5 12 9.58 7.41 5 6 6.41l6 6z"></path>
          <path d="m18 13-1.41-1.41L12 16.17l-4.59-4.58L6 13l6 6z"></path>
        </svg>
      );
    case "double-arrow-up":
      return (
        <svg
          class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSvgIcon-root MuiSvgIcon-fontSizeLarge css-zjt8k"
          focusable="false"
          aria-hidden="true"
          viewBox="0 0 24 24"
          data-testid="KeyboardDoubleArrowUpIcon"
          tabindex="-1"
          title="KeyboardDoubleArrowUp"
        >
          <path d="M6 17.59 7.41 19 12 14.42 16.59 19 18 17.59l-6-6z"></path>
          <path d="m6 11 1.41 1.41L12 7.83l4.59 4.58L18 11l-6-6z"></path>
        </svg>
      );
    // case 'normal-arrow-down' :
    //   return (

    //   )
    case "parent":
      return (
        <svg
          width="28px"
          height="28px"
          viewBox="0 0 24 24"
          version="1.1"
        >
          <title>location_2_fill</title>
          <g
            id="页面-1"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="location_2_fill">
              <path
                d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z"
                id="MingCute"
                fill-rule="nonzero"
              ></path>
              <path
                d="M6.72009,16.6398 C7.25029,16.4853 7.80543,16.7897 7.96003,17.32 C8.11462,17.8502 7.81012,18.4053 7.27991,18.5599 C6.77914,18.7059 6.41926,18.8607 6.18866,18.9996 C6.42735,19.1433 6.80251,19.303 7.32497,19.4523 C8.47958,19.7822 10.1328,19.9996 12,19.9996 C13.8672,19.9996 15.5204,19.7822 16.675,19.4523 C17.1975,19.303 17.5726,19.1433 17.8113,18.9996 C17.5807,18.8607 17.2209,18.7059 16.7201,18.5599 C16.1899,18.4053 15.8854,17.8502 16.04,17.32 C16.1946,16.7897 16.7497,16.4853 17.2799,16.6398 C17.948,16.8346 18.5608,17.0847 19.0293,17.4058 C19.4655,17.7048 20,18.2259 20,18.9996 C20,19.7832 19.4522,20.3078 19.0097,20.6067 C18.5322,20.9292 17.9071,21.1803 17.2245,21.3753 C15.8456,21.7693 13.9988,21.9996 12,21.9996 C10.0012,21.9996 8.15442,21.7693 6.77553,21.3753 C6.09289,21.1803 5.46776,20.9292 4.99033,20.6067 C4.54781,20.3078 4,19.7832 4,18.9996 C4,18.2259 4.53454,17.7048 4.97068,17.4058 C5.43918,17.0847 6.05202,16.8346 6.72009,16.6398 Z M12,2 C16.1421,2 19.5,5.35786 19.5,9.5 C19.5,12.0679 18.1005,14.1564 16.6502,15.6391 C16.0352526,16.2678158 15.3907163,16.8089881 14.7970227,17.2550925 C14.2033291,17.7011969 12.8455,18.5365 12.8455,18.5365 C12.3176,18.8347 11.6824,18.8347 11.1545,18.5365 C10.6266,18.2383 9.79665913,17.7011969 9.20296073,17.2550925 C8.60926233,16.8089881 7.96472316,16.2678158 7.34978,15.6391 C5.89953,14.1564 4.5,12.0679 4.5,9.5 C4.5,5.35786 7.85786,2 12,2 Z M12,7.5 C10.8954,7.5 10,8.39543 10,9.5 C10,10.6046 10.8954,11.5 12,11.5 C13.1046,11.5 14,10.6046 14,9.5 C14,8.39543 13.1046,7.5 12,7.5 Z"
                id="形状"
                fill="#09244B"
                fill-rule="nonzero"
              ></path>
            </g>
          </g>
        </svg>
      );
      case 'pencil-edit':
        return(
          <svg viewBox="64 64 896 896" focusable="false" data-icon="edit" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"></path></svg>
        )
      case 'Profiles':
        return <svg viewBox="64 64 896 896" focusable="false" data-icon="profile" fill="currentColor" aria-hidden="true"><path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM492 400h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM340 368a40 40 0 1080 0 40 40 0 10-80 0zm0 144a40 40 0 1080 0 40 40 0 10-80 0zm0 144a40 40 0 1080 0 40 40 0 10-80 0z"></path></svg>                
      case 'PortFolios':
        return <svg viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
        <path fill-rule="evenodd" d="M7.5 5.25a3 3 0 013-3h3a3 3 0 013 3v.205c.933.085 1.857.197 2.774.334 1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.726 24.726 0 0112 15.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A48.814 48.814 0 017.5 5.455V5.25zm7.5 0v.09a49.488 49.488 0 00-6 0v-.09a1.5 1.5 0 011.5-1.5h3a1.5 1.5 0 011.5 1.5zm-3 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z" clip-rule="evenodd" />
        <path d="M3 18.4v-2.796a4.3 4.3 0 00.713.31A26.226 26.226 0 0012 17.25c2.892 0 5.68-.468 8.287-1.335.252-.084.49-.189.713-.311V18.4c0 1.452-1.047 2.728-2.523 2.923-2.12.282-4.282.427-6.477.427a49.19 49.19 0 01-6.477-.427C4.047 21.128 3 19.852 3 18.4z" />
        </svg>      
        case 'Domain Admin':
          return <svg  viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
                <path fill-rule="evenodd" d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z" clip-rule="evenodd" />
            </svg>
    default:
      break;
  }
}
